import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { CellularPayPrompt } from './types'
import { Banner } from './banner'
import { HostedInvoiceLink } from './payment-failure'
import { achEndedMessage, achPendingMessage, endedAch, pendingAch, trustedPendingAch } from './ach'
import { isSimOff } from './sim-status'
import { color } from './tokens'

// While a bank payment is on its way (or waits for the test deposits) the bill
// counts as paid: no lock, no pop-up, no "Pay Now" that would charge it twice.
// Typed numbers get the link to Stripe's page where the deposits are confirmed.
export const AchBanner: FC<{ prompt: CellularPayPrompt }> = ({ prompt }) => {
  const ach = pendingAch(prompt)
  if (!ach) return null
  return (
    <Banner
      message={achPendingMessage(prompt, isSimOff(prompt))}
      tone='warning'
    >
      {ach.state === 'waiting_deposits' && ach.verificationUrl && (
        <HostedInvoiceLink
          label='Confirm the deposits'
          url={ach.verificationUrl}
        />
      )}
    </Banner>
  )
}

const useNoticeStyles = makeStyles({
  box: {
    padding: '12px 16px',
    borderRadius: 8,
    fontSize: 14,
    lineHeight: '20px',
    color: color.foreground,
    textAlign: 'center',
    backgroundColor: color.destructive15
  },
  text: { margin: 0, fontWeight: 500 }
})

// Why the bill is owed again after a bank payment: it failed, or got no answer in 7 days —
// or, while a later bank payment on it clears, that the service unlocks once it lands.
export const AchEndedNotice: FC<{ prompt: CellularPayPrompt }> = ({ prompt }) => {
  const classes = useNoticeStyles()
  const clearing = pendingAch(prompt) && !trustedPendingAch(prompt)
  if (!endedAch(prompt) && !clearing) return null
  return (
    <div
      className={classes.box}
      data-testid='cellular-ach-ended'
      role='status'
    >
      <p className={classes.text}>{clearing ? achPendingMessage(prompt) : achEndedMessage(prompt)}</p>
    </div>
  )
}
